import { RefObject, useCallback, useEffect } from 'react';

/*
 * The callback prop is assumed to have logical equality to
 * avoid having to wrap the passed callback in useCallback
 */
const useClickOutside = <T extends HTMLElement[]>(
  refs: { [K in keyof T]: RefObject<T[K]> },
  callback: () => void
) => {
  const onClick = useCallback(
    (e: MouseEvent) => {
      refs.every(ref => !ref.current?.contains(e.target as Node)) && callback();
    },
    // Deliberately do not pass dependencies - ignore referential equality
    // eslint-disable-next-line
    []
  );

  useEffect(() => {
    window.addEventListener('click', onClick);
    return () => window.removeEventListener('click', onClick);
  }, [onClick, refs]);
};

export default useClickOutside;
